import React from "react";
import "./pages.css"
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCirclePlay, faMoneyBill1Wave, faChartLine, faShirt} from "@fortawesome/free-solid-svg-icons";

// BOOTSTRAP IMPORTATION
// import {Button} from 'react-bootstrap';
// BOOTSTRAP IMPORTATION



// SIDE SHOW LIBIARY
import { Fade  } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import higheProfite from "../../Resources/slideshow/SLIDE_HIGHER_PROFITS.png"
import robustScaling from "../../Resources/slideshow/SLIDE_ROBUST_SCALING.png"
import bestSelection from "../../Resources/slideshow/SLIDE_BEST_SELECTION.gif"
import customizer from "../../Resources/slideshow/CUSTOMIZERS_BULK_ORDER.gif"

// SLIDE SHOW LIBARY

// ANIMATION

import ScrollAnimatiion from 'react-animate-on-scroll'

// ANIMATION


// import logo from "../../Resources/global.png"
import ButtonHover from "../Inc/button-over";
import Hfc from "../Inc/hfc";
import Ppd from "../Inc/ppd";
import CYS from "../Inc/cys"
import Pspp from "../Inc/pspp";
// import {ReactComponent  as slideShow} from "../../Resources/theHiveSlideShow(1).svg"

const Home = () =>{

    const pwa = {
        HIGHER_PROFITS: [
            "We offer some of the lowest prices in the industries because print providers continuously compete to win your business.",
            faMoneyBill1Wave
        ],
        ROBUST_SCALING: [
            "Easily handle peak holiday seasons, with our wide network of partners and automatic routing functionality.",
            faChartLine
        ],
        BEST_SELECTION: [
            "With 600+ products and top-quality brand, you can choose the best products for your business.",
            faShirt
        ],
    }

    const slideInfo = {
        HIGHER_PROFITS: [
            "Higher Profits",
            "We offer some of the lowest prices in the industries because print providers continuously compete to win your business.",
            higheProfite
        ],
        ROBUST_SCALING: [
            "Robust Scaling",
            "Easily handle peak holiday seasons, with our wide network of partners and automatic routing functionality.",
            robustScaling
        ],
        BEST_SELECTION: [
            "Best Selection",
            "With 600+ products and top-quality brand, you can choose the best products for your business.",
            bestSelection
        ],
        // CUSTOMIZER: [
        //     "Customizers",
        //     "The hive is in collaboration between Global T-Shirt Factorie for organizations or indiviguales who will like to order in bulk quantity",
        //     customizer
        // ],
    }

    const customizerSlide = {
        
        CUSTOMIZER: [
            "Customizers",
            "The hive is in collaboration between Global T-Shirt Factorie for organizations or indiviguales who will like to order in bulk quantity",
            customizer
        ],
    }
    return(
        <Container fluid style={{position: "relative"}}>
            {
                <>
                    {/* <Row className="home-top-section">
                        <Col className="home-top-svg" sm={6}>
                            <img src={logo} alt="Illustrative iamge of The Hive" />
                        </Col>
                        <Col className="home-top-info" sm={6}>
                            <div className="home-top-info-position">
                                <h1>
                                    Create and sell custom products
                                </h1>
                                <span>
                                    <ul>
                                        <li>
                                            <FontAwesomeIcon icon={faCheck} />{" "}
                                            Create and sell custom products
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCheck} />{" "}
                                            Introductory video of how products work.
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCheck} />{" "}
                                            Animation design of user and products
                                        </li>
                                    </ul>
                                </span>
                                <div className="home-top-info-btn">
                                    <Button variant="warning" className="me-20">Start Selling</Button>
                                    <Button variant="outline-warning">
                                        <FontAwesomeIcon icon={faCirclePlay} className="fa-thin" />
                                        How It Works?
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row> */}
                    <div className="container-slide-body">
                        <div className="container-slide-show">
                            <div className="container-main-section">
                                <Fade  arrows={false} cssClass="slideShow-img">
                                    {
                                        Object.keys(slideInfo).map((val, idx)=>{
                                            return(
                                                <div key={idx} className="container-slides">
                                                    <div className="container-images-img">
                                                        <img src={slideInfo[val][2]} alt="slide show images" />
                                                    </div>
                                                    <div className="container-images-info">
                                                        <h1>
                                                            {slideInfo[val][0]}

                                                        </h1>
                                                        <p>
                                                            {slideInfo[val][1]}
                                                        </p>
                                                        <div className="container-btn-info">
                                                            <Button variant="warning">Start Designe</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    <div className="container-slides">
                                        <div className="container-images-img">
                                            <img src={customizerSlide["CUSTOMIZER"][2]} alt="slide show images" />
                                        </div>
                                        <div className="container-images-info">
                                            <h2>
                                                {customizerSlide["CUSTOMIZER"][0]}

                                            </h2>
                                            <p>
                                                {customizerSlide["CUSTOMIZER"][1]}
                                            </p>
                                            <div className="container-btn-info">
                                                <Button variant="warning">Order In Bulk</Button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="container-slides">
                                        <div className="container-images-img">
                                            <img src={robustScaling} alt="first slide show" />
                                        </div>
                                        <div className="container-images-info">
                                            <>text info</>
                                        </div>
                                    </div>
                                    <div className="container-slides">
                                        <div className="container-images-img">
                                            <img src={bestSelection} alt="first slide show" />
                                        </div>
                                        <div className="container-images-info">
                                            <>text info</>
                                        </div>
                                    </div>
                                    <div className="container-slides">
                                        <div className="container-images-img">
                                            <img src={customizer} alt="first slide show" />
                                        </div>
                                        <div className="container-images-info">
                                            <>text info</>
                                        </div>
                                    </div> */}
                                </Fade>
                            </div>
                        </div>
                    </div>
                </>
            }
            {/* PORPOSE OF WEB APPICATION */}
            <Row className="purposeofwebapp-section">

                {/* {
                    Object.keys(pwa).map((val, idx)=>(
                       
                        <ButtonHover key={idx} icons={pwa[val][1]} 
                                    info={pwa[val][0]} val={val} alt={val}/>


                    ))
                } */}
               <div className="custom-shape-divider-bottom-1672831910">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M649.97 0L599.91 54.12 550.03 0 0 0 0 120 1200 120 1200 0 649.97 0z" className="shape-fill"></path>
                    </svg>
                </div>

            </Row>
            
            <Hfc />
            <Ppd />
            <CYS />
            <Row className="banner-create-design">
                <div className="banner-create-design-div">
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 235">
                        <path fill="#f8a000" fill-opacity="1" d="M0,64L40,101.3C80,139,160,213,240,224C320,235,400,181,480,149.3C560,117,640,107,720,128C800,149,880,203,960,192C1040,181,1120,107,1200,106.7C1280,107,1360,181,1400,218.7L1440,256L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
                    </svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 235">
                        <path fill="#f8a000" fill-opacity="1" d="M0,96L60,96C120,96,240,96,360,85.3C480,75,600,53,720,85.3C840,117,960,203,1080,218.7C1200,235,1320,181,1380,154.7L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
                    </svg> */}
                    <div className="banner-info-btn">
                        <h5>
                            Are you a large business looking for custom solutions?
                        </h5>
                    </div>
                    <div className="banner-info-btn">
                        <Button style={{padding: "10px"}} variant="warning">Start Designe</Button>
                    </div>
                </div>
            </Row>
            <Pspp />
        </Container>
    );
}

export default Home